import React from 'react';
import { WaitingTime } from 'AppClient/api/Bookings/BokkingsTypes';
import { BookingDictionariesStore, RootStore } from 'AppClient/stores';
import { inject, observer } from 'mobx-react';
import {
	WaitingTimeChargingType,
	WaitingTimeCategoryType,
	WAITING_TIME_CHARGING_TYPE_MAP,
	WAITING_TIME_CATEGORY_TYPE_MAP,
} from 'app-types';
import { find } from 'lodash-es';
import { FormattedMinutesText } from './FormattedMinutesText';

interface Props {
	data: WaitingTime | null;
	bookingDictionariesStore?: BookingDictionariesStore;
	serviceProviderCurrencySymbol: string;
}

@inject(({ bookingDictionariesStore }: RootStore) => ({
	bookingDictionariesStore,
}))
@observer
export class WaitingTimeTCText extends React.Component<Props> {
	getTitle = () => <h5>Waiting time charges</h5>;

	getContent = () => {
		const { data } = this.props;
		if (!data) {
			return this.emptyContent();
		}

		return this.fullContent(data);
	};

	emptyContent = () => <p>There is no waiting time charge.</p>;

	getCarTypeName = (carTypeId: number) => {
		const { findCarById } = this.props.bookingDictionariesStore!;
		const carDetails = findCarById(carTypeId);
		let carTypeName;

		if (carDetails === null) {
			carTypeName = 'All Services';
		}

		if (carDetails) {
			carTypeName = carDetails.carTypeName;
		}

		return carTypeName;
	};

	getChargingName = (chargingType: WaitingTimeChargingType) => {
		const type = find(WAITING_TIME_CHARGING_TYPE_MAP, ['id', chargingType]);
		let name;

		if (type) {
			name = type.name.split(' ')[0].toLowerCase();
		}

		return name;
	};

	getCategoryName = (categotyType: WaitingTimeCategoryType) => {
		const type = find(WAITING_TIME_CATEGORY_TYPE_MAP, ['id', categotyType]);
		let name;

		if (type) {
			name = type.name;
		}

		return name;
	};

	fullContent = ({
		carTypeId,
		freeMinutes,
		hourlyRate,
		callOffPolicyMinutes,
		chargingType,
		category,
	}: WaitingTime) => {
		const { serviceProviderCurrencySymbol } = this.props;
		const carTypeName = this.getCarTypeName(carTypeId);
		const chargingName = this.getChargingName(chargingType);
		const categoryName = this.getCategoryName(category);

		if (!carTypeName || !chargingName || !categoryName) {
			return null;
		}

		return (
			<div>
				<p>
					If waiting time states 'free minutes', waiting time will be charged once the
					allocated 'free minutes' have overrun. If waiting time states 'grace minutes',
					waiting time will be charged from minute 1 once the allocated 'grace minutes'
					have overrun.
				</p>
				<ul>
					<li>
						<strong>
							{carTypeName} of {categoryName} category
						</strong>
						: You will have{' '}
						<strong>
							{freeMinutes} <FormattedMinutesText value={freeMinutes} />{' '}
							{chargingName} waiting time
						</strong>
						, thereafter charge at{' '}
						<strong>
							{hourlyRate} {serviceProviderCurrencySymbol} per hour
						</strong>{' '}
						and your driver will wait until{' '}
						<strong>
							{callOffPolicyMinutes}{' '}
							<FormattedMinutesText value={callOffPolicyMinutes} /> after pick up
							time.
						</strong>
					</li>
				</ul>
			</div>
		);
	};

	render() {
		return (
			<>
				{this.getTitle()}
				{this.getContent()}
			</>
		);
	}
}
